import React, { useState, Fragment } from "react";
import { Img } from "../../../subComponents/img";
import { Heading } from "../../../subComponents/Heading";
import { Card, Box, Button, Modal, Fade, Backdrop, Grid } from "@mui/material";

const certificationList = [
  {
    id: 1,
    title: "IATF 16949:2016 (In Process - Dec 2026)",
    imageUrl: "/assets/images/certification/ISO.jpg",
    pdfUrl: "/assets/images/certification/ISO.pdf",
  },
  // {
  //   id: 2,
  //   title: "GSTIN",
  //   imageUrl: "/assets/images/certification/2.png",
  //   pdfUrl: "/assets/images/certification/ISO.pdf",
  // },
  // {
  //   id: 3,
  //   title: "MSME",
  //   imageUrl: "/assets/images/certification/3.png",
  //   pdfUrl: "/assets/images/certification/ISO.pdf",
  // },
  // {
  //   id: 4,
  //   title: "IEC",
  //   imageUrl: "/assets/images/certification/4.png",
  //   pdfUrl: "/assets/images/certification/ISO.pdf",
  // },
];

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 1,
  outline: "none",
  width: "90vw",
  height: "90vh", // PDF view ke liye height zaroori hai
  display: "flex",
  flexDirection: "column"
};

export default function CertificationCard() {
  const [open, setOpen] = useState(false);
  const [selectedPdf, setSelectedPdf] = useState("");

  const handleOpen = (url) => {
    setSelectedPdf(url);
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  return (
    <Fragment>
      {/* Grid Container: Desktop pe 4 (12/3=4) aur Mobile pe 1 (12/12=1) */}
      <Grid container spacing={3} justifyContent={"center"} >
        {certificationList.map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item.id}>
            <Card
              sx={{
                position: "relative",
                overflow: "hidden",
                height: "100%",
                "&:hover .overlay": { opacity: 1 },
              }}
            >
              <Img
                src={item.imageUrl}
                alt={item.title}
                style={{ width: "100%",  objectFit: "cover", display: "block" }}
              />

              <Box
                className="overlay"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  bgcolor: "rgba(0,0,0,0.8)",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  opacity: 0,
                  transition: "opacity 0.3s ease-in-out",
                  color: "#fff",
                  p: 2,
                }}
              >
                <Heading
                  title={item.title}
                  style={{ textAlign: "center", marginBottom: "15px", fontSize: '1rem' }}
                />
                <Button
                  variant="contained"
                  size="small"
                  onClick={() => handleOpen(item.pdfUrl)} 
                  style={{
                    minWidth: "120px",
                    width:"100%",
                    maxHeight:"max-content",
                    backgroundColor: "var(--orange)",
                    padding:"0.8rem 0"
                  }}
                >
                  View PDF
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* PDF Preview Modal */}
      <Modal
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{ backdrop: { timeout: 500 } }}
      >
        <Fade in={open}>
          <Box sx={modalStyle}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end',maxHeight:"50px" }}>
              <div onClick={handleClose} sx={{ color: 'black', minWidth: 'auto' }}>
                <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                  <path fill="currentColor" d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12z" />
                </svg>
              </div>
            </Box>
            
            {/* iframe for PDF display */}
            <Box sx={{ flexGrow: 1, width: '100%', overflow: 'hidden' }}>
              <iframe
                src={`${selectedPdf}#toolbar=0`} // #toolbar=0 optional hai buttons hide karne ke liye
                width="100%"
                height="100%"
                style={{ border: 'none' }}
                title="PDF Preview"
              />
            </Box>
          </Box>
        </Fade>
      </Modal>
    </Fragment>
  );
}